import axios from 'axios';

class PrivacyAgreeService {
  //[I-04] DFD-RSV-WEBS-THRD 내 정보 관리 제 3자제공 동의
  async myMenuCcrcThrd({ hspId, hspCd, usrId, ccrcTp }) {
    // return axios.get(`mock/ccrc-thrd.json`);
    const url = `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/ccrc-thrd/${hspId}/${hspCd}/${usrId}`;
    return axios.get(url, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      params: {
        ccrcTp,
      },
    });
  }
  //[I-05] DFD-RSV-WEBS-THRD-RSLT 내 정보 관리 제 3자제공 동의 결과
  async myMenuCcrcThrdRslt(params) {
    const url = `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/ccrc-thrd-rslt`;
    return axios.post(url, params, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  }
}
export default new PrivacyAgreeService();
